import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class SubpropertyService {
    static async update(id, data, manage) {
        const response = await graphqlClient.mutate({
            mutation: gql `
        mutation _SLUG(
          $id: String!
          $data: SubpropertyInput!
          $manage: ManageInput!
        ) {
          subpropertyUpdate(id: $id, data: $data, manage: $manage) {
            id
          }
        }
      `,

            variables: {
                id,
                data,
                manage,
            },
        });

        return response.data.subpropertyUpdate;
    }

    static async destroyAll(ids, manage) {
        const response = await graphqlClient.mutate({
            mutation: gql `
        mutation SUBPROPERTY_DESTROY($ids: [String!]! $manage: ManageInput!) {
          subpropertyDestroy(ids: $ids, manage: $manage)
        }
      `,

            variables: {
                ids,
                manage,
            },
        });

        return response.data.subpropertyDestroy;
    }

    static async create(data, manage) {
        const response = await graphqlClient.mutate({
            mutation: gql `
        mutation SUBPROPERTY_CREATE($data: SubpropertyInput! $manage: ManageInput!) {
          subpropertyCreate(data: $data, manage: $manage) {
            id
          }
        }
      `,

            variables: {
                data,
                manage,
            },
        });

        return response.data.subpropertyCreate;
    }

    static async import (values, importHash, manage) {
        const response = await graphqlClient.mutate({
            mutation: gql `
        mutation SUBPROPERTY_IMPORT(
          $data: SubpropertyInput!
          $importHash: String!
          $manage: ManageInput!
        ) {
          subpropertyImport(data: $data, importHash: $importHash, manage: $manage)
        }
      `,

            variables: {
                data: values,
                importHash,
                manage,
            },
        });

        return response.data.subpropertyImport;
    }

    static async find(id, manage) {
        const response = await graphqlClient.query({
            query: gql `
        query SUBPROPERTY_FIND($id: String! $manage: ManageInput!) {
          subpropertyFind(id: $id, manage: $manage) {
            id
            name
            slug
            status
            access
            emails
            country
            region
            propertyId
            managers {
              id
              email
              fullName
            }
            createdAt
            updatedAt
            logo {
              id
              name
              sizeInBytes
              publicUrl
              privateUrl
            }
            owqloFeeFixed
            owqloFeePercentage
            connectedAccountId
            paymentsEnabled
            birthdateType
            dateFormat
            timeFormat
          }
        }
      `,

            variables: {
                id,
                manage,
            },
        });

        return response.data.subpropertyFind;
    }

    static async dashboard(id) {
        const response = await graphqlClient.query({
            query: gql `
        query SUBPROPERTY_DASHBOARD($id: String!) {
          subpropertyDashboard(id: $id) {
            stats {
              type
              amount
            }
          }
        }
      `,

            variables: {
                id,
            },
        });
        return response.data.subpropertyDashboard;
    }

    static async finantialOverview(id) {
        const response = await graphqlClient.query({
            query: gql `
        query SUBPROPERTY_FINANTIAL_OVERVIEW($id: String!) {
          subpropertyFinantialOverview(id: $id) {
            slug
            country
            owqloFee {
              fixedAmount
              percentage
            }
            connectedAccountEnabled
            defaultCurrency
          }
        }
      `,

            variables: {
                id,
            },
        });
        return response.data.subpropertyFinantialOverview;
    }

    static async requirementSteps(propertyId, subpropertyId, userId) {
        const response = await graphqlClient.query({
            query: gql `
        query SUBPROPERTY_REQUIREMENT_STEPS($propertyId: String!, $subpropertyId: String!, $userId: String!) {
          subpropertyRequirementSteps(propertyId: $propertyId, subpropertyId: $subpropertyId, userId: $userId) {
            steps {
              key
              done
              active
            }
            connectedAccountId
          }
        }
      `,

            variables: {
                propertyId,
                subpropertyId,
                userId,
            },
        });
        return response.data.subpropertyRequirementSteps;
    }

    static async list(filter, orderBy, limit, offset, manage) {
        const response = await graphqlClient.query({
            query: gql `
        query SUBPROPERTY_LIST(
          $filter: SubpropertyFilterInput
          $orderBy: SubpropertyOrderByEnum
          $limit: Int
          $offset: Int
          $manage: ManageInput!
        ) {
          subpropertyList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
            manage: $manage
          ) {
            count
            rows {
                id
                name
                status
                access
                country
                region
                emails
                stripeData {
                    balanceTotal {
                        amount
                        currency
                    }
                }
                programs {
                    id
                    name
                    type
                    status
                }
                property {
                    id
                    name
                }
                managers {
                    id
                    email
                    fullName
                }
                updatedAt
                createdAt
                logo {
                    id
                    name
                    sizeInBytes
                    publicUrl
                    privateUrl
                }
                owqloFeeFixed
                owqloFeePercentage
                connectedAccountId
                paymentsEnabled
                birthdateType
                dateFormat
                timeFormat
            }
          }
        }
      `,

            variables: {
                filter,
                orderBy,
                limit,
                offset,
                manage,
            },
        });

        return response.data.subpropertyList;
    }

    static async listAutocomplete(query, limit, manage) {
        const response = await graphqlClient.query({
            query: gql `
        query SUBPROPERTY_AUTOCOMPLETE(
          $query: String
          $limit: Int
          $manage: ManageInput!
        ) {
          subpropertyAutocomplete(query: $query, limit: $limit, manage: $manage) {
            id
            label
          }
        }
      `,

            variables: {
                query,
                limit,
                manage,
            },
        });

        return response.data.subpropertyAutocomplete;
    }

    static async listStripeData(subpropertyId) {
        const response = await graphqlClient.query({
            query: gql `
        query SUBPROPERTY_LIST_STRIPE_DATA($subpropertyId: String!) {
          subpropertyListStripeData(id: $subpropertyId) {
            balanceTotal {
              amount 
              currency
            }
          }
        }
      `,

            variables: {
                subpropertyId
            },
        });

        return response.data.subpropertyListStripeData;
    }

    static async listExternalAccounts(subpropertyId) {
        const response = await graphqlClient.query({
            query: gql `
        query SUBPROPERTY_LIST_EXTERNAL_ACCOUNTS($subpropertyId: String!) {
          subpropertyListExternalAccounts(id: $subpropertyId) {
            id
            last4
          }
        }
      `,

            variables: {
                subpropertyId
            },
        });

        return response.data.subpropertyListExternalAccounts;
    }
    
    static async stripeData({ subpropertyId }) {
      if (!subpropertyId ) return
  
      const response = await graphqlClient.query({
        query: gql`
          query SUBPROPERTY_STRIPE_DATA(
            $subpropertyId: String!
          ) {
            stripeSubpropertyDataFind(
              subpropertyId: $subpropertyId
            ) {
              owqloFee {
                fixedAmount
                percentage
              }
              connectedAccount {
                address {
                  country
                }
                defaultCurrency
              }
            }
          }
        `,
  
        variables: {
          subpropertyId
        },
      });
  
      return response.data.stripeSubpropertyDataFind;
    }
  

    // Slug
    static async slug(subpropertyId) {
        const response = await graphqlClient.query({
            query: gql `
        query SUBPROPERTY_SLUG($subpropertyId: String!) {
          subpropertySlug(subpropertyId: $subpropertyId) 
        }
      `,

            variables: {
                subpropertyId,
            },
        });
        return response.data.subpropertySlug;
    }

    static async checkExistsSlug(slug) {
        const response = await graphqlClient.query({
            query: gql `
        query SUBPROPERTY_CHECK_EXISTS_SLUG($slug: String!) {
          subpropertyCheckExistsSlug(slug: $slug) 
        }
      `,

            variables: {
                slug,
            },
        });
        return response.data.subpropertyCheckExistsSlug;
    }

    static async updateSlug(subpropertyId, slug) {
        const response = await graphqlClient.mutate({
            mutation: gql `
        mutation SUBPROPERTY_UPDATE_SLUG(
          $subpropertyId: String!
          $slug: String!
        ) {
          subpropertyUpdateSlug(subpropertyId: $subpropertyId, slug: $slug)
        }
      `,

            variables: {
                subpropertyId,
                slug,
            },
        });

        return response.data.subpropertyUpdateSlug;
    }
}